import { Link } from 'react-router-dom';
import JsonLd from './JsonLd';

const Breadcrumbs = ({ trail }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": trail.map((t, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": t.name,
      "item": t.url
    }))
  };

  return (
    <>
      <JsonLd data={schema} />
      <nav className="breadcrumbs">
        {trail.map((t, i) => (
          <span key={i}>
            <Link to={t.url}>{t.name}</Link>
            {i < trail.length - 1 && ' › '}
          </span>
        ))}
      </nav>
    </>
  );
};

export default Breadcrumbs; 